import React from "react";

const AboutUsPage = () => {
    return (
        <h1>getting started - jsx</h1>
    );
}

export default AboutUsPage;